// Fatia S1: pedir link de nova senha (resposta sempre igual, não revela se o e-mail existe).
import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { api, errorMessage } from '../../lib/api'
import AuthShell, { FormError, FormOk } from '../../features/auth/AuthShell'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await api.post('/auth/forgot-password', { email })
      setSent(true)
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthShell title="Esqueceu a senha?" sub="Informe seu e-mail e mandamos um link para criar uma nova." footer={<Link className="strong" style={{ color: 'var(--primary)' }} to="/login">Voltar para o login</Link>}>
      {sent ? (
        <FormOk>Se existir uma conta com <b>{email}</b>, você vai receber o link em alguns minutos. Confira também a caixa de spam. O link vale por 1 hora.</FormOk>
      ) : (
        <form className="stack" style={{ gap: 14 }} onSubmit={submit}>
          <FormError error={error} />
          <div className="field">
            <label htmlFor="email">E-mail</label>
            <input id="email" className="input" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <button className="btn primary lg block" disabled={busy}>{busy ? 'Enviando…' : 'Enviar link'}</button>
        </form>
      )}
    </AuthShell>
  )
}
